/* eslint-disable no-unused-vars */
import './index.css';

const SuraSansRegular = require('../../../assets/fonts/SuraSans-Regular.woff2')
const SuraSansMedium = require('../../../assets/fonts/SuraSans-Seminegrita.woff2')